<div class="page-layout flex-vertical gap-32 align-self-stretch">
  @if (isNotHabilitedWarning) {
    <oui-banner
      title="Vous n'avez aucune habilitation active en placement"
      declination="error"
    [action]="noHabilAction"></oui-banner>
  }
  <app-user-notification (onActionClicked)="goToCreationPM()"> </app-user-notification>

  <div class="flex-horizontal width-100pc">
    <h4 class="flex-none">Mes opérations</h4>
    <div class="flex-auto"></div>
    <div class="flex-none">
      <div class="flex-horizontal height-100pc gap-16">
        <oui-button
          class="align-self-center"
          type="outlined"
          size="large"
          (click)="onDeclareActeButtonClick()"
          [disabled]="isNotHabilitedWarning"
          >Déclarer un acte de gestion</oui-button
          >
          <oui-button
            class="align-self-center"
            type="contained"
            size="large"
            (click)="onDeclareSubsButtonClick()"
            [disabled]="isNotHabilitedWarning"
            >Déclarer une souscription</oui-button
            >
          </div>
        </div>
      </div>
      @if (tabService.tabs && tabService.tabs.length) {
        <div class="flex-none width-100pc">
          <oui-tab-group class="tabs" [navigation]="true" class="flex-none">
            @for (tab of tabService.tabs; track tab; let i = $index) {
              <oui-tab [label]="tab.label" [routerLink]="tab.dashboardKey">
              </oui-tab>
            }
          </oui-tab-group>
          <router-outlet class="width-100pc"></router-outlet>
        </div>
      } @else {
        <oui-loading class="flex-horizontal width-100pc justify-center flex-center min-height-500"></oui-loading>
      }
    </div>
